import { useState, useEffect, useRef } from "react";
import { getStamp, uploadStamp, deleteStamp } from "../api";
import { toast } from "./Toast";
import "./StampUpload.css";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8000";

export default function StampUpload() {
  const [stamp, setStamp] = useState(null);
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);

  useEffect(() => {
    loadStamp();
  }, []);

  async function loadStamp() {
    try {
      const data = await getStamp();
      setStamp(data);
    } catch {
      setStamp(null);
    } finally {
      setLoading(false);
    }
  }

  async function handleUpload(e) {
    const file = e.target.files[0];
    if (!file) return;

    const validTypes = ["image/png", "image/jpeg", "image/webp"];
    if (!validTypes.includes(file.type)) {
      toast("მხოლოდ PNG, JPEG ან WebP ფორმატი.", "error");
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      toast("ფაილის ზომა არ უნდა აღემატებოდეს 5MB-ს.", "error");
      return;
    }

    setUploading(true);
    try {
      const data = await uploadStamp(file);
      setStamp(data);
      toast("ბეჭედი წარმატებით აიტვირთა.", "success");
    } catch (err) {
      toast(err.message || "ატვირთვა ვერ მოხერხდა.", "error");
    } finally {
      setUploading(false);
      if (fileInputRef.current) fileInputRef.current.value = "";
    }
  }

  async function handleDelete() {
    if (!stamp) return;
    try {
      await deleteStamp(stamp.id);
      setStamp(null);
      toast("ბეჭედი წაიშალა.", "success");
    } catch (err) {
      toast(err.message || "წაშლა ვერ მოხერხდა.", "error");
    }
  }

  function getImageUrl(stampImage) {
    if (!stampImage) return null;
    if (stampImage.startsWith("http")) return stampImage;
    return `${API_BASE_URL}${stampImage}`;
  }

  if (loading) {
    return <div className="stamp-loading">იტვირთება...</div>;
  }

  return (
    <div className="stamp-upload">
      <h3 className="stamp-title">კომპანიის ბეჭედი</h3>
      <p className="stamp-desc">
        ატვირთეთ კომპანიის ბეჭდის სურათი. ის ავტომატურად გამოჩნდება PDF პასუხებზე ხელმოწერის არეში.
      </p>

      {stamp && stamp.stamp_image ? (
        <div className="stamp-preview-area">
          <div className="stamp-preview-box">
            <img
              src={getImageUrl(stamp.stamp_image)}
              alt="ბეჭედი"
              className="stamp-preview-img"
            />
          </div>
          <div className="stamp-actions">
            <label className="stamp-replace-btn">
              შეცვლა
              <input
                ref={fileInputRef}
                type="file"
                accept="image/png,image/jpeg,image/webp"
                onChange={handleUpload}
                hidden
              />
            </label>
            <button className="stamp-delete-btn" onClick={handleDelete}>
              წაშლა
            </button>
          </div>
        </div>
      ) : (
        <label className="stamp-upload-zone">
          <div className="stamp-upload-icon">📎</div>
          <div className="stamp-upload-text">
            {uploading ? "იტვირთება..." : "აირჩიეთ ბეჭდის სურათი"}
          </div>
          <div className="stamp-upload-hint">PNG, JPEG ან WebP (მაქს. 5MB)</div>
          <input
            ref={fileInputRef}
            type="file"
            accept="image/png,image/jpeg,image/webp"
            onChange={handleUpload}
            disabled={uploading}
            hidden
          />
        </label>
      )}
    </div>
  );
}
